import styled from "styled-components";

export const AppContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2.5rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const ProfileImageContainer = styled.div`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: #e9ecef;
  border: 5px solid #fff;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 480px) {
    width: 140px;
    height: 140px;
  }
`;

export const ProfileAvatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ProfileImageSection = styled.div`
  flex: 0 0 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);

  @media (max-width: 1024px) {
    flex: 0 0 250px;
    padding: 1.5rem;
  }

  @media (max-width: 768px) {
    flex: unset;
    width: 100%;
    flex-direction: row;
    justify-content: flex-start;
    gap: 1rem;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const MainContent = styled.div`
  flex: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow-y: auto;

  @media (max-width: 768px) {
    padding: 1rem;
    max-height: calc(73vh - 2rem);
    overflow-y: auto;
  }
`;

export const CompactInfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const CompactInfoCard = styled.div`
  background-color: #fff;
  padding: 1.2rem;
  border-radius: 10px;
  border: 1px solid #eee;

  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

export const CardTitle = styled.h3`
  margin: 0 0 1rem 0;
  color: #2c3e50;
  font-size: 1.1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #eee;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

export const CompactInfoRow = styled.div`
  display: flex;
  margin-bottom: 0.7rem;
  flex-wrap: wrap;
`;

export const CompactLabel = styled.span`
  font-weight: bold;
  color: #444;
  min-width: 120px;
  font-size: 0.9rem;

  @media (max-width: 480px) {
    min-width: 100px;
    font-size: 0.85rem;
  }
`;

export const CompactValue = styled.span`
  color: #555;
  flex: 1;
  font-size: 0.9rem;

  @media (max-width: 480px) {
    font-size: 0.85rem;
  }
`;

export const DocumentsContainer = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const CompactDocumentCard = styled.div`
  flex: 1;
  min-width: 180px;
  max-width: 210px;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid #eee;

  @media (max-width: 480px) {
    min-width: 100%;
    max-width: 100%;
  }
`;

export const DocumentPreview = styled.img`
  width: 100%;
  height: 100px;
  border-radius: 6px;
  object-fit: cover;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  margin-bottom: 0.5rem;
`;

export const DocumentLink = styled.a`
  display: block;
  text-align: center;
  color: #16706a;
  text-decoration: none;
  font-size: 0.8rem;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: bold;
  background-color: ${(props) =>
    props.status === "ONLINE"
      ? "rgba(46, 125, 50, 0.1)"
      : props.status === "OFFLINE"
      ? "rgba(198, 40, 40, 0.1)"
      : props.status === "IN_TRIP"
      ? "#6cbb8954"
      : "rgba(85, 85, 85, 0.1)"};
  color: ${(props) =>
    props.status === "ONLINE"
      ? "#2e7d32"
      : props.status === "OFFLINE"
      ? "#c62828"
      : props.status === "IN_TRIP"
      ? "#0a5c56"
      : "#555"};

  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 0.3rem 0.8rem;
  }
`;

export const ProfileContainer = styled.div`
  display: flex;
  min-height: 73vh;
  width: 75%;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  font-family: "Noto Kufi Arabic", sans-serif;
  direction: rtl;
  overflow: visible;

  @media (max-width: 1024px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
    width: 100%;
    border-radius: 12px;
  }
`;
